import React, { useEffect } from "react";

import { Box } from "@mui/material";
import { SelectOption } from "components/forms";
import { DealGraph } from "components/reports";
import { useTimelineTable } from "components/reports/ReportMeasuresTable/useTimelineTable";
import { useActionHook, useReportMeasuresGroupByOptions } from "hooks";
import { MaterialReactTable } from "material-react-table";
import { useRefetchReportsSelect, useReportsActions, useReportsQueriesSelector } from "store";

export const Timeline: React.FC = () => {
  const {
    dateRange,
    secondaryDateRange,
    measures,
    groupBy,
    calculatedFields,
    comparisonColumns,
    rowBy,
    currency,
    filters,
    mainParameter,
    secondaryParameter,
    interval,
    cumulative,
    originalCurrency,
    characteristics,
    exchangeMethod,
    use_accounting_date,
    groupByGraph,
    columnType
  } = useReportsQueriesSelector();
  const refetchReport = useRefetchReportsSelect();

  const { getReportTableAction, getMeasureGraphAction, getMetaAction, refetchReportAction } = useReportsActions();

  useEffect(() => {
    getMetaAction();
  }, []);
  const {
    action: getGraph,
    loading: isGraphLoading,
    data: dealGraph
  } = useActionHook(() =>
    getMeasureGraphAction({
      withinDeal: false,
      allowCumulative: true,
      filters,
      dateRange,
      mainParameter,
      secondaryParameter,
      interval,
      currency,
      exchangeMethod,
      cumulative,
      use_accounting_date,
      groupByGraph,
      columnType
    })
  );

  const { action: refetch, loading } = useActionHook(() =>
    getReportTableAction({
      dateRange,
      measures,
      columnBy: "timeline",
      groupBy,
      calculatedFields,
      rowBy,
      currency,
      originalCurrency,
      characteristics,
      filters,
      exchangeMethod,
      use_accounting_date,
      columns: []
    })
  );

  useEffect(() => {
    if (refetchReport === "timeline") {
      refetch();
      getGraph();
      refetchReportAction(null);
    }
  }, [refetchReport]);

  useEffect(() => {
    refetch();
  }, [
    secondaryDateRange,
    measures,
    groupBy,
    calculatedFields,
    comparisonColumns,
    rowBy,
    currency,
    filters,
    originalCurrency,
    exchangeMethod,
    dateRange,
    use_accounting_date,
    columnType
  ]);

  useEffect(() => {
    getGraph();
  }, [
    dateRange,
    currency,
    filters,
    mainParameter,
    secondaryParameter,
    interval,
    cumulative,
    exchangeMethod,
    use_accounting_date,
    groupByGraph,
    columnType
  ]);

  const groupByOptions: SelectOption[] = useReportMeasuresGroupByOptions();

  const table = useTimelineTable({ isLoading: loading, groupByOptions });
  return (
    <>
      <div className="white-box">
        <DealGraph loading={isGraphLoading} graphData={dealGraph} />
      </div>
      <Box
        sx={{
          width: "100%",
          height: "100%"
          // ".MuiTableContainer-root": { maxHeight: "calc(100% - 180px)" } // 90px - filters static height + 90px more for monthly view
        }}
        className="measures-table"
      >
        <MaterialReactTable table={table} />
      </Box>
    </>
  );
};
